import { Collapse, Typography } from '@material-ui/core';
import { License } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';
import { InfoPrompt } from '@swf/first';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import { collapse, container } from '../../../BalanceRecord/BalanceRecord.scss';
import BalanceRecordItem from '../../../BalanceRecordItem/BalanceRecordItem';
import type { Props } from '../../OtherBalances';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import {
  bonusCurrency,
  recordTitle,
  recordTotal,
  recordValue,
  separator
} from '../../OtherBalances.scss';

import {
  TXTCLI_In_Play,
  TXTWCL_For_more_details_on_bonus_amou_ELL_2,
  TXTWCL_Instant_bonus,
  TXTWCL_Surrender_Credits,
  TXTWCL_The_Bonus_package_could_includ_ELL,
  TXTWCL_This_contributed_amount_can_be_ELL,
  TXTWCL_This_is_the_combined_total_of__ELL_2,
  TXTWCL_This_value_is_the_combined_tot_ELL,
  TXTWCL_Winnings_derived_from_stakes_p_ELL,
  TXTWCL_You_may_surrender_each_bonus_f_ELL_2
} from './InstantBonusBalances.messages.json';

const InstantBonusBalances: React.FC<Props> = ({ balances }) => {
  const [bonusExpanded, setBonusExpanded] = useState(false);
  const [linkClicked, setLinkClicked] = useState(false);
  const license = useSelector(select.account.getLicense);
  const brand = useSelector(select.cms.getBrandName);
  const { modal } = useDispatch<Dispatch>();
  const isEmbedded = useSelector(select.device.isEmbedded);

  const onClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      setLinkClicked(true);
      if (isEmbedded) {
        window.starsweb?.app.execute('awardstatus/InstantBonuses');
      } else {
        modal.enqueue({
          path: '/account/my-stars/bonus/instant-bonuses'
        });
      }
    },
    [modal, isEmbedded]
  );

  return (
    <>
      <div onClick={() => setBonusExpanded(!bonusExpanded)}>
        <BalanceRecordItem
          className={recordTitle}
          label={<Translation {...TXTWCL_Instant_bonus} />}
          expand={bonusExpanded}
          isHeader
        />
      </div>
      <Collapse className={container} in={bonusExpanded}>
        {balances.map(
          (
            { currency, instantBonusTotal, instantBonusInPlay, userRollsSurrenderAmount },
            index
          ) => (
            <div key={currency} className={collapse}>
              {!!instantBonusTotal && (
                <BalanceRecordItem
                  className={recordTotal}
                  currency={currency}
                  balance={instantBonusTotal}
                  label={
                    <Translation {...TXTWCL_Instant_bonus}>
                      {(translation) => (
                        <>
                          <span
                            data-testid="bonus-currency"
                            className={bonusCurrency}
                          >{`${currency} - `}</span>
                          {translation}
                        </>
                      )}
                    </Translation>
                  }
                  info={
                    <InfoPrompt
                      title={{ translation: TXTWCL_Instant_bonus }}
                      variant="wallet"
                      hidePrompt={linkClicked}
                      onCloseCallback={() => setLinkClicked(false)}
                    >
                      <Typography>
                        <Translation {...TXTWCL_This_value_is_the_combined_tot_ELL} />{' '}
                        <Translation {...TXTWCL_The_Bonus_package_could_includ_ELL} />{' '}
                        <Translation {...TXTWCL_This_contributed_amount_can_be_ELL} />{' '}
                        <Translation
                          {...TXTWCL_Winnings_derived_from_stakes_p_ELL}
                          values={{ accountBrand: brand }}
                        />{' '}
                        <Translation
                          {...TXTWCL_For_more_details_on_bonus_amou_ELL_2}
                          values={{
                            a: (msg: string) => <StarsLink onClick={onClick}>{msg}</StarsLink>
                          }}
                        />
                      </Typography>
                    </InfoPrompt>
                  }
                  isInstantBonus
                />
              )}
              {!!instantBonusInPlay && license === License.IT && (
                <BalanceRecordItem
                  className={recordValue}
                  currency={currency}
                  balance={instantBonusInPlay}
                  label={<Translation {...TXTCLI_In_Play} />}
                />
              )}
              {!!userRollsSurrenderAmount && (
                <BalanceRecordItem
                  className={recordValue}
                  currency={currency}
                  balance={userRollsSurrenderAmount}
                  label={<Translation {...TXTWCL_Surrender_Credits} />}
                  info={
                    <InfoPrompt
                      title={{ translation: TXTWCL_Surrender_Credits }}
                      variant="wallet"
                      hidePrompt={linkClicked}
                      onCloseCallback={() => setLinkClicked(false)}
                    >
                      <Typography>
                        <Translation {...TXTWCL_This_is_the_combined_total_of__ELL_2} />{' '}
                        <Translation
                          {...TXTWCL_You_may_surrender_each_bonus_f_ELL_2}
                          values={{
                            a: (msg: string) => <StarsLink onClick={onClick}>{msg}</StarsLink>
                          }}
                        />
                      </Typography>
                    </InfoPrompt>
                  }
                />
              )}
              {balances.length - 1 > index && <div className={separator} />}
            </div>
          )
        )}
      </Collapse>
    </>
  );
};

export default InstantBonusBalances;
